/* Native details retain click and keyboard access if this enhancement is unavailable. */
if (!customElements.get('ks-navigation')) {
  customElements.define('ks-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const close = (except) => {
        this.querySelectorAll('details[open]').forEach(item => {
          if (item !== except) item.open = false;
        });
      };
      this.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        if (summary && this.contains(summary)) close(summary.parentElement);
      }, options);
      this.addEventListener('keydown', event => {
        const item = event.target.closest('.ks-nav__details');
        if (!item) return;
        if (event.key === 'Escape' && item.open) {
          event.preventDefault();
          event.stopPropagation();
          item.open = false;
          item.querySelector('summary').focus();
        } else if (event.key === 'ArrowDown' && event.target.matches('summary')) {
          event.preventDefault();
          close(item);
          item.open = true;
          item.querySelector('a')?.focus();
        }
      }, options);
      this.addEventListener('focusout', event => {
        const item = event.target.closest('.ks-nav__details');
        if (item && !item.contains(event.relatedTarget)) item.open = false;
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) close();
      }, options);
      window.addEventListener('pageshow', () => close(), options);
      this.breakpoint = window.matchMedia('(min-width: 1200px)');
      this.breakpoint.addEventListener('change', () => close(), options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
